export default "__VITE_ASSET__D3iEn$mb__"